import { useEffect, useState } from 'react';

/**
 * Hook réactif sur navigator.onLine + écoute des events `online` / `offline`.
 * Note : navigator.onLine est imparfait (peut dire true même sans Internet réel),
 * mais suffisant comme premier filet. La vraie détection se fait via le retour
 * des requêtes API (erreurs réseau).
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );

  useEffect(() => {
    const onOnline  = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener('online',  onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online',  onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return online;
}
